import React, {useEffect, useState} from 'react';
import css from './Resume.module.scss'
import image from "../../../../images/standing-empty-log.svg";
import darkImage from '../../../../images/white_man.svg'
import plus from "../../../../images/plus.svg";
import arrow from "../../../../images/down.svg";
import {Field, Formik} from "formik";
import share from '../../../../images/white_share.svg'
import edit from '../../../../images/edit_icon.svg'
import ResumeInput from "./ResumeInput";
import circle from '../../../../images/blue-circle.svg'
import {CustomCheckBox} from "../../logbook/EditTable";
import {CO_SHKIPER, experiences, roles, SHKIPER} from "../../../../redux/types";
import calendar from "../../../../images/calendar.svg";
import {fromDateToStringDate, fromStringDateToDate, getFormattedDate, isCyrilic, testDate} from "../../../../utils";
import {DateRange} from "react-date-range";
import line from "../../../../images/line.svg";
import plusIcon from '../../../../images/blue-plus.svg'
import {RemoveScrollBar} from "react-remove-scroll-bar";
import HideTrips from "../../../common/modals/HideTrips";
import SendResume from "../../../common/modals/SendResume";
import InviteMember from "../../../common/modals/InviteMember";
import TripsTable from "../../../common/TripsTable/TripsTable";
import {connect} from "react-redux";
import {
  addResumeCharters,
  addResumeLicenses,
  getLicenses,
  getResume, getResumeCharters,
  getResumeLicenses,
  updateResume
} from "../../../../redux/profile/profile-thunks";
import {getCommonData} from "../../../../redux/data/data-thunks";
import {CREW_ROLES, MARINAS, YACHT_TYPES} from "../../../../redux/data/data-types";
import {dataApi} from "../../../../redux/data/data-api";
import ConfirmEmail from "../../../common/modals/ConfirmEmail";
import {sendConfirmEmail, updateProfile} from "../../../../redux/user/user-thunks";
import {useTranslation} from "react-i18next";
import {setTrips} from "../../../../redux/logbook/logbook-actions";

const Resume = ({isDark, resume, resumeLicenses, ...props}) => {
  const [isResume, setIsResume] = useState(false)
  const [isEdit, setIsEdit] = useState(false)
  const {t} = useTranslation()
  const [state, setState] = useState([
    {
      startDate: new Date(),
      endDate: null,
      key: 'selection'
    }
  ])
  const [isHideModal, setIsHideModal] = useState(false)
  const [isSendResume, setIsSendResume] = useState(false)
  const [isInviteModal, setIsInviteModal] = useState(false)
  const [isShowConfirmEmail, setIsShowConfirmEmail] = useState(false)
  console.log(resume)
  useEffect(() => {
    props.setTrips([])
    if (props.user) {
      props.getLicenses()
      props.getCommonData(YACHT_TYPES)
      props.getCommonData(MARINAS)
      props.getCommonData(CREW_ROLES)
      props.getResume()
      props.getResumeLicenses()
      props.getResumeCharters()
    }
  }, [props.user])

  const onSave = async (values, setFieldError) => {
    let isAnyError = false
    let response = await dataApi.getData(MARINAS, values.port)
    let marinas = response.data
    let own_boat_marina_name = values.port
    let own_boat_type_name = values.boatType
    if (marinas.find(m => m.name === values.port) === undefined && values.port.length > 0) {
      // isAnyError = true
      // setFieldError('port', t('marinaNotFound'))
      if(!isCyrilic(values.port)) {
        isAnyError = true
        setFieldError('port', `${t('enter')} ${t('port')} ${t('onlyEnglish')}`)
      }
    }
    if(props.yachtTypes.find(y => y.name === values.boatType) === undefined && values.boatType.length > 0) {
      if(!isCyrilic(values.boatType)) {
        isAnyError = true
        setFieldError('boatType', `${t('enter')} ${t('yachtType')} ${t('onlyEnglish')}`)
      }
    }
    if (/[^a-z, 0-9, ^\\p{P}+$+/]/i.test(values.name)) {
      isAnyError = true
      setFieldError('name', `${t('enter')} ${t('name')} ${t('onlyEnglish')}`)
    }
    if (/[^a-z, 0-9, ^\\p{P}+$+/]/i.test(values.surname)) {
      isAnyError = true
      setFieldError('surname', `${t('enter')} ${t('surname')} ${t('onlyEnglish')}`)
    }
    if (values.birth?.length === 10 && !testDate(values.birth)) {
      isAnyError = true
      setFieldError('birth', t('invalidDate'))
    }
    // if(/[^a-z, 0-9, ^\\p{P}+$+/]/i.test(values.address)) {
    //   isAnyError = true
    //   setFieldError('address', `${t('enter')} ${t('address')} ${t('onlyEnglish')}`)
    // }
    if (!isAnyError) {
      if (fromStringDateToDate(values.birth) !== props.profile.birth_date) {
        props.updateProfile(
          props.profile.first_name,
          props.profile.last_name,
          props.profile.phone_number,
          fromStringDateToDate(values.birth)
        )
      }
      props.addResumeLicenses(values.selectedLicenses)
      props.addResumeCharters(values.isBareboat ? values.selectedCharters : [])
      props.updateResume({
        first_name: values.name,
        last_name: values.surname,
        birth_date: values.birth ? fromStringDateToDate(values.birth) : null,
        phone_number: values.phone,
        email: values.email,
        address: values.address,
        have_license: values.selectedLicenses !== null,
        have_own_boat: values.isOwnBoat,
        sailing_since: values.since ? `${values.since}-01-01` : null,
        own_boat_length: (values.boatLength.length === 0 || !values.isOwnBoat) ? 0 : values.boatLength,
        own_boat_type_id: (!values.isOwnBoat || props.yachtTypes.find(y => y.name === values.boatType) === undefined) ? null : props.yachtTypes.find(y => y.name === values.boatType).id,
        own_boat_marina_id: (!values.isOwnBoat || marinas.find(m => m.name === values.port) === undefined) ? null : marinas.find(m => m.name === values.port).id,
        own_boat_marina_name,
        own_boat_type_name,
        is_docking_alongside: values.is_docking_alongside,
        is_plotting: values.is_plotting,
        is_reading_nautical_charts: values.is_reading_nautical_charts,
        is_coastal_navigation: values.is_coastal_navigation,
        is_picking_up_mooring: values.is_picking_up_mooring,
        is_single_bow_anchor: values.is_single_bow_anchor
      })
      setIsEdit(false)
    }
  }

  return (
    <div className={`${css.resume__wrapper}`}>
      {(isHideModal || isSendResume || isInviteModal || isShowConfirmEmail) && <>
        <RemoveScrollBar/>
        <div className="overlay"/>
      </>}
      {isShowConfirmEmail && <ConfirmEmail closeModal={() => setIsShowConfirmEmail(false)}
                                           onSubmit={() => {
                                             props.sendConfirmEmail()
                                             setIsShowConfirmEmail(false)
                                           }}/>}
      {isSendResume && <SendResume onWatch={() => {
        setIsSendResume(false)
        setIsEdit(false)
      }} closeModal={() => setIsSendResume(false)}/>}
      {isInviteModal && <InviteMember closeModal={() => setIsInviteModal(false)}/>}
      {(resume !== undefined && resumeLicenses !== null && props.licenses !== null && props.resumeCharters !== null && props.profile !== null) && <>
        {(!isResume && (resume === null)) ?
          <div className={`${css.resume__empty} wrapper`}>
            <div className={`empty ${isDark && 'empty__dark'}`}>
              <img src={isDark ? darkImage : image} alt=""/>
              <div className={'empty__info'}>
                <p className={'empty__title'}>
                  {t('hasntCreatedResume')}
                </p>
                <p className={'empty__text'}>
                  {t('toCreateResume')}
                </p>
                <p className={'empty__text'}>
                  {t('beforeCreateResume')}
                </p>
                <button onClick={() => {
                  if (props.trips?.length > 0 && props.licenses.length > 0 && props.user?.is_active === true) {
                    setIsEdit(true)
                    setIsResume(true)
                  } else {
                    setIsShowConfirmEmail(true)
                  }
                }} className={'empty__create'}>
                  <img src={plus} alt=""/>
                  {t('createResume')}
                </button>
              </div>
            </div>
          </div> : <Formik
            initialValues={{
              name: resume?.first_name ?? '',
              surname: resume?.last_name ?? '',
              birth: props.profile?.birth_date ? fromDateToStringDate(props.profile?.birth_date) : null,
              phone: resume?.phone_number ?? '',
              email: resume?.email ?? '',
              address: resume?.address ?? '',
              since: resume?.sailing_since ? new Date(resume?.sailing_since).getFullYear() : '',
              selectedLicenses: resumeLicenses.map((lic) => lic.id),
              isOwnBoat: !!resume?.have_own_boat,
              boatType: resume?.own_boat_type?.name ?? resume?.own_boat_type_name ?? '',
              boatLength: resume?.own_boat_length ?? '',
              port: resume?.own_boat_marina?.name ?? resume?.own_boat_marina_name ?? '',
              isBareboat: props.resumeCharters.length !== 0,
              selectedCharters: props.resumeCharters.map((lic) => lic.id),
              is_coastal_navigation: resume?.is_coastal_navigation,
              is_docking_alongside: resume?.is_docking_alongside,
              is_picking_up_mooring: resume?.is_picking_up_mooring,
              is_plotting: resume?.is_plotting,
              is_reading_nautical_charts: resume?.is_reading_nautical_charts,
              is_single_bow_anchor: resume?.is_single_bow_anchor,
              isShowLink: false,
              isAddCrew: false,
              crewName: '',
              crewSurname: '',
              crewPhone: '',
              crewEmail: '',
              crewAddress: '',
              crewSince: '',
              crewSelectedLicenses: [],
              crewIsOwnBoat: false,
              crewBoat: '',
              crewBoatLength: '',
              crewPort: '',
              crewIsChartered: false,
              crewCompany: '',
              crewFromDate: '',
              crewToDate: '',
              crewRole: '',
              crewBoatType: '',
              crewNm: '',
              crewDays: '',
              crewAreas: '',
              crewSelectedExperience: []
            }}
          >
            {({
                values, handleChange, handleSubmit,
                setFieldValue, setFieldError, errors
              }) => {
              if (props.licenses.length > 0 && values.selectedLicenses !== null && values.selectedLicenses?.length === 0) {
                setFieldValue('selectedLicenses', props.licenses.map(l => l.id))
              }
              return <div className={`${css.resume} resume ${isDark && `${css.resume__dark} resume__dark`}`}>
                {isHideModal && <HideTrips closeModal={() => {
                  setIsHideModal(false)
                }} onSubmit={() => {
                  setFieldValue('isBareboat', false)
                  setIsHideModal(false)
                }}/>}
                <div className="modal__row space-between flex-start">
                  <h5 className="modal__mainTitle modal__row space-between w-100">
                    <span className={'mt-10'}>{t('sailResume')}</span>
                    {!isEdit && <div className="modal__actions">
                      <button onClick={() => setIsEdit(true)}
                              className={`commonBtn mr-12 ${isDark && 'commonBtn__dark'}`}>
                        <img className={`${isDark && 'white-img'}`} src={edit} alt=""/>
                        <span className="commonBtn__label">{t('edit')}</span>
                      </button>
                      <button onClick={() => setIsSendResume(true)} className="submit-button m-0">
                        <img src={share} alt=""/>
                        {t('send')}
                      </button>
                    </div>}
                  </h5>
                </div>
                <div className="modal__section">
                  <input id={'check'} type="checkbox" className={'modal__check'}/>
                  <label htmlFor={'check'} className="modal__subTitle">
                    <h6 className="modal__underTitle">{t('personalInfo')}</h6>
                    <div className="modal__collapse">
                      <img src={arrow} alt=""/>
                    </div>
                  </label>
                  <div className="modal__inputs">
                    <p className={css.resume__text}>1. Skipper</p>
                    <div className={css.resume__inputs}>
                      <ResumeInput caption={`${t('name')}:`} value={values.name} isEdit={isEdit}
                                   handleChange={handleChange}
                                   id={'name'} type={'text'} setFieldValue={setFieldValue} error={errors.name}/>
                      <ResumeInput caption={`${t('surname')}:`} value={values.surname} isEdit={isEdit}
                                   handleChange={handleChange} error={errors.surname}
                                   id={'surname'} type={'text'} setFieldValue={setFieldValue}/>
                      <ResumeInput caption={`${t('birthDate')}:`} value={values.birth} isEdit={isEdit}
                                   handleChange={handleChange} id={'birth'} setFieldError={setFieldError}
                                   setFieldValue={setFieldValue} placeholder={'Выберите дату'} type={'text'}
                                   error={errors.birth}/>
                      <ResumeInput caption={`${t('phoneNumber')}:`} value={values.phone} isEdit={isEdit}
                                   handleChange={handleChange} setFieldValue={setFieldValue}
                                   id={'phone'}/>
                      <ResumeInput caption={`${t('email')}:`} value={values.email} isEdit={isEdit}
                                   handleChange={handleChange}
                                   id={'email'} type={'email'} setFieldValue={setFieldValue}/>
                      <ResumeInput caption={`${t('address')}:`} value={values.address} isEdit={isEdit}
                                   handleChange={handleChange} error={errors.address}
                                   placeholder={t('addressPlaceholder')}
                                   id={'address'} type={'text'} setFieldValue={setFieldValue}/>
                    </div>
                  </div>
                </div>
                <div className="modal__section">
                  <input id={'check2'} type="checkbox" className={'modal__check'}/>
                  <label htmlFor={'check2'} className="modal__subTitle">
                    <h6 className="modal__underTitle">{t('yachtExp')}</h6>
                    <div className="modal__collapse">
                      <img src={arrow} alt=""/>
                    </div>
                  </label>
                  <div className="modal__inputs">
                    <p
                      className={css.resume__text}>2. {t('howLongSailing')}</p>
                    <div className={css.resume__inputs}>
                      <ResumeInput caption={`${t('since')}:`} value={values.since} isEdit={isEdit}
                                   handleChange={handleChange}
                                   id={'since'} isArrow={true} readonly={true}
                                   list={[...Array(71)].map((_, index) => new Date().getFullYear() - index)
                                     .map((y, index) => <button className="modal__listItem"
                                                                onClick={() => setFieldValue('since', y)} key={index}>
                                       {y}
                                     </button>)} type={'number'}/>
                      <ResumeInput caption={`${t('years')}:`}
                                   value={values.since && new Date().getFullYear() - +values.since}
                                   isEdit={isEdit} handleChange={handleChange}
                                   id={'years'} readonly={true} type={'number'}/>
                    </div>
                    <p
                      className={`${css.resume__text} mt-10`}>3. {t('doHaveLicenses')}</p>
                    <div className={'modal__row space-between'}>
                      <div className={'w-48'}>
                        <CustomCheckBox isDark={isDark} caption={t('yes')}
                                        onClick={() => {
                                          if (isEdit) setFieldValue('selectedLicenses', [])
                                        }}
                                        isChecked={values.selectedLicenses !== null} color={'#575758'}
                                        fontFamily={'Lato600'}/>
                      </div>
                      <div className="w-48">
                        <CustomCheckBox isDark={isDark}
                                        caption={t('no')} onClick={() => {
                          if (isEdit) setFieldValue('selectedLicenses', null)
                        }}
                                        isChecked={values.selectedLicenses === null}
                                        color={'#575758'} fontFamily={'Lato600'}/>
                      </div>
                    </div>
                    <div>
                      {values.selectedLicenses !== null && props.licenses.map((lic, index) => {
                        let license = props.licenses.find(l => l.id === lic.id ?? lic)
                        if(!license || (values.selectedLicenses.indexOf(license.id) === -1 && !isEdit)) return null
                          return <CustomCheckBox isDark={isDark}
                                                 caption={`${license.license_system.name}, ${license.license_type.name},   ${license.license_number}, ${license.issue_date}`}
                                                 key={index}
                                                 onClick={() => {
                                                   if (!isEdit) return
                                                   if (values.selectedLicenses.indexOf(license.id) === -1) {
                                                     setFieldValue('selectedLicenses', [...values.selectedLicenses, license.id])
                                                   } else {
                                                     if (values.selectedLicenses.length === 1) setFieldValue('selectedLicenses', null)
                                                     else setFieldValue('selectedLicenses', [...values.selectedLicenses].filter(s => s !== license.id))
                                                   }
                                                 }}
                                                 isChecked={values.selectedLicenses.indexOf(license.id) !== -1}
                                                 color={'#575758'} fontFamily={'Lato600'}/>
                        }
                      )}
                    </div>
                    <p
                      className={`${css.resume__text} mt-10`}>4. {t('doOwnBoat')}</p>
                    <div className={'modal__row space-between'}>
                      <div className="w-48">
                        <CustomCheckBox isDark={isDark} caption={t('yes')} isChecked={values.isOwnBoat}
                                        onClick={() => {
                                          if(isEdit) setFieldValue('isOwnBoat', true)
                                        }}
                                        color={'#575758'} fontFamily={'Lato600'}/>
                      </div>
                      <div className="w-48">
                        <CustomCheckBox isDark={isDark} caption={t('no')} isChecked={!values.isOwnBoat}
                                        onClick={() => {
                                          if(isEdit) setFieldValue('isOwnBoat', false)
                                        }}
                                        color={'#575758'} fontFamily={'Lato600'}/>
                      </div>
                    </div>
                    {values.isOwnBoat && <div className={css.resume__inputs}>
                      <ResumeInput caption={t('type')} value={values.boatType}
                                   error={errors.boatType}
                                   isEdit={isEdit} handleChange={handleChange}
                                   id={'boatType'} type={'text'} isArrow={true}
                                   list={props.yachtTypes.map((y, index) => (
                                     <button className="modal__listItem"
                                             onClick={() => setFieldValue('boatType', y.name)} key={index}>
                                       {y.name}
                                     </button>))}/>
                      <ResumeInput caption={t('length')} value={values.boatLength}
                                   isEdit={isEdit} handleChange={(e) => {
                        if (!isNaN(e.target.value) && e.target.value.length < 6) {
                          handleChange(e)
                        }
                      }} setFieldValue={setFieldValue}
                                   id={'boatLength'} isArrow={true} inputWidth={106} postCaption={t('metres')}/>
                      <ResumeInput caption={t('port')} value={values.port} error={errors.port}
                                   isEdit={isEdit} handleChange={e => {
                        handleChange(e)
                        props.getCommonData(MARINAS, e.target.value)
                      }} autoComplete={'off'}
                                   id={'port'} type={'text'} isArrow={true} list={props.marinas.map((m, index) => (
                        <button className="modal__listItem"
                                onClick={() => setFieldValue('port', m.name)} key={index}>
                          {m.name}
                        </button>))}/>
                    </div>}
                    <p
                      className={`${css.resume__text} mt-10`}>5. {t('haveBareboat')}</p>
                    <div className={'modal__row space-between'}>
                      <div className="w-48">
                        <CustomCheckBox isDark={isDark} caption={t('yes')} isChecked={values.isBareboat}
                                        onClick={() => {
                                          if(isEdit) setFieldValue('isBareboat', true)
                                        }}
                                        color={'#575758'} fontFamily={'Lato600'}/>
                      </div>
                      <div className="w-48">
                        <CustomCheckBox isDark={isDark} caption={t('no')} isChecked={!values.isBareboat}
                                        onClick={() => {
                                          if(isEdit) setIsHideModal(true)
                                        }}
                                        color={'#575758'} fontFamily={'Lato600'}/>
                      </div>
                    </div>
                    {(values.isBareboat || !isEdit) &&
                    <TripsTable isEdit={isEdit} charters={props.trips ?? []} setFieldValue={setFieldValue}
                                selectedCharters={values.selectedCharters} isDark={isDark}/>}
                    <div className={css.resume__experience}>
                      <div className={css.resume__expCol}>
                        <div className="modal__row mb-12">
                          <p className={css.resume__totalLabel}>{t('totalExp')} <span
                            className="font700">&nbsp;skipper</span>:
                          </p>
                          <p
                            className={css.resume__totalCount}>{props.experience?.role_experience?.find(e => e.role.name === 'Skipper')?.miles ?? 0} {t('nm')}</p>
                          <p
                            className={css.resume__totalCount}>{props.experience?.role_experience?.find(e => e.role.name === 'Skipper')?.days ?? 0} {t('days')}</p>
                        </div>
                        <div className="modal__row">
                          <p className={css.resume__totalLabel}>{t('totalExp')}<span
                            className="font700">&nbsp;co-skipper</span>:</p>
                          <p
                            className={css.resume__totalCount}>{props.experience?.role_experience?.find(e => e.role.name === 'Co-skipper')?.miles ?? 0} {t('nm')}</p>
                          <p
                            className={css.resume__totalCount}>{props.experience?.role_experience?.find(e => e.role.name === 'Co-skipper')?.days ?? 0} {t('days')}</p>
                        </div>
                      </div>
                      <div className={css.resume__expCol}>
                        <p className={css.resume__totalLabel}>
                          {isEdit && <CustomCheckBox isDark={isDark} marginBottom={'0px'} isChecked={values.isShowLink}
                                                     onClick={() => setFieldValue('isShowLink', !values.isShowLink)}/>}
                          <span className={`${isEdit && 'ml--22'}`}>{t('showLogbookLink')}:</span>
                        </p>
                        <p className={`${css.resume__link} ${isEdit && 'ml-28'}`}>https://online-logbook.eu/logbook/</p>
                      </div>
                    </div>
                    <p
                      className={`${css.resume__text}`}>6. {t('knowAndExp')}</p>
                    <div className={css.resume__inputs}>
                      <div className={`w-48`}>
                        <CustomCheckBox isDark={isDark} caption={t('dockingAlongside')} color={'#252526'}
                                        fontFamily={'Lato400'}
                                        isChecked={values.is_docking_alongside}
                                        onClick={() => {
                                          if (isEdit) setFieldValue('is_docking_alongside', !values.is_docking_alongside)
                                        }}/>
                      </div>
                      <div className={`w-48`}>
                        <CustomCheckBox isDark={isDark} caption={t('plotting')} color={'#252526'} fontFamily={'Lato400'}
                                        isChecked={values.is_plotting}
                                        onClick={() => {
                                          if (isEdit) setFieldValue('is_plotting', !values.is_plotting)
                                        }}/>
                      </div>
                      <div className={`w-48`}>
                        <CustomCheckBox isDark={isDark} caption={t('readingNaut')} color={'#252526'}
                                        fontFamily={'Lato400'}
                                        isChecked={values.is_reading_nautical_charts}
                                        onClick={() => {
                                          if (isEdit) setFieldValue('is_reading_nautical_charts', !values.is_reading_nautical_charts)
                                        }}/>
                      </div>
                      <div className={`w-48`}>
                        <CustomCheckBox isDark={isDark} caption={t('coastNav')} color={'#252526'}
                                        fontFamily={'Lato400'}
                                        isChecked={values.is_coastal_navigation}
                                        onClick={() => {
                                          if (isEdit) setFieldValue('is_coastal_navigation', !values.is_coastal_navigation)
                                        }}/>
                      </div>
                      <div className={`w-48`}>
                        <CustomCheckBox isDark={isDark} caption={t('pickMoor')} color={'#252526'}
                                        fontFamily={'Lato400'}
                                        isChecked={values.is_picking_up_mooring}
                                        onClick={() => {
                                          if (isEdit) setFieldValue('is_picking_up_mooring', !values.is_picking_up_mooring)
                                        }}/>
                      </div>
                      <div className={`w-48`}>
                        <CustomCheckBox isDark={isDark} caption={t('signleBow')} color={'#252526'}
                                        fontFamily={'Lato400'}
                                        isChecked={values.is_single_bow_anchor}
                                        onClick={() => {
                                          if (isEdit) setFieldValue('is_single_bow_anchor', !values.is_single_bow_anchor)
                                        }}/>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="modal__section">
                  <input id={'check3'} type="checkbox" className={'modal__check'}/>
                  <label htmlFor={'check3'} className="modal__subTitle">
                    <h6 className="modal__underTitle">{t('crewMan')}</h6>
                    <div className="modal__collapse">
                      <img src={arrow} alt=""/>
                    </div>
                  </label>
                  <div className="modal__inputs">
                    <p
                      className={css.resume__text}>7. {isEdit ? t('isAddCrew') : t('infoCrew')}</p>
                    {isEdit && <div className={'modal__row space-between'}>
                      <div className="w-48">
                        <CustomCheckBox isDark={isDark} caption={t('yes')} isChecked={values.isAddCrew}
                                        onClick={() => setFieldValue('isAddCrew', true)}
                                        color={'#575758'} fontFamily={'Lato600'}/>
                      </div>
                      <div className="w-48">
                        <CustomCheckBox isDark={isDark} caption={t('no')} isChecked={!values.isAddCrew}
                                        onClick={() => setFieldValue('isAddCrew', false)}
                                        color={'#575758'} fontFamily={'Lato600'}/>
                      </div>
                    </div>}
                    {(isEdit && values.isAddCrew) && <div className="modal__row flex-center">
                      <button onClick={() => setIsInviteModal(true)} className="submit-button mr-12">
                        {t('inviteMember')}
                      </button>
                      <p className={css.resume__label}>
                        {t('orFullManually')}
                      </p>
                    </div>}
                    {values.isAddCrew && <>
                      <div className="modal__inputs show-block">
                        <p className={css.resume__text}>7.1. {t('crewPersonalInfo')}</p>
                        <div className={css.resume__inputs}>
                          <ResumeInput caption={`${t('name')}:`} value={values.crewName} isEdit={isEdit}
                                       handleChange={handleChange}
                                       id={'crewName'} type={'text'} setFieldValue={setFieldValue}/>
                          <ResumeInput caption={`${t('surname')}:`} value={values.crewSurname} isEdit={isEdit}
                                       handleChange={handleChange}
                                       id={'crewSurname'} type={'text'} setFieldValue={setFieldValue}/>
                          <ResumeInput caption={`${t('phoneNumber')}:`} value={values.crewPhone} isEdit={isEdit}
                                       handleChange={handleChange}
                                       id={'crewPhone'}/>
                          <ResumeInput caption={`${t('email')}:`} value={values.crewEmail} isEdit={isEdit}
                                       handleChange={handleChange}
                                       id={'crewEmail'} type={'email'}/>
                          <ResumeInput caption={`${t('address')}:`} value={values.crewAddress} isEdit={isEdit}
                                       handleChange={handleChange}
                                       id={'crewAddress'} type={'text'} setFieldValue={setFieldValue}/>
                        </div>
                      </div>
                      <div className="modal__inputs show-block">
                        <p
                          className={css.resume__text}>7.2. {isEdit ? t('howLongCrewSail') : t('yachtExp')}</p>
                        <div className={`${css.resume__inputs}`}>
                          <ResumeInput caption={`${t('since')}:`} value={values.crewSince} isEdit={isEdit}
                                       handleChange={handleChange}
                                       id={'crewSince'} isArrow={true} readonly={true}
                                       list={[...Array(71)].map((_, index) => new Date().getFullYear() - index)
                                         .map((y, index) => <button className="modal__listItem"
                                                                    onClick={() => setFieldValue('crewSince', y)}
                                                                    key={index}>
                                           {y}
                                         </button>)} type={'number'}/>
                          <ResumeInput caption={`${t('years')}:`}
                                       value={values.crewSince && new Date().getFullYear() - +values.crewSince}
                                       isEdit={isEdit} handleChange={handleChange}
                                       id={'crewYears'} readonly={true} type={'number'}/>
                        </div>
                      </div>
                      <p
                        className={css.resume__text}>7.3. {isEdit ? t('isCrewLicenses') : t('sailBoatLicenses')}</p>
                      {isEdit ? <>
                        <div className={'modal__row space-between'}>
                          <div className={'w-48'}>
                            <CustomCheckBox isDark={isDark} caption={t('yes')}
                                            onClick={() => setFieldValue('crewSelectedLicenses', [])}
                                            isChecked={values.crewSelectedLicenses !== null} color={'#575758'}
                                            fontFamily={'Lato600'}/>
                            {values.crewSelectedLicenses !== null && values.crewSelectedLicenses.map((lic, index) => (
                              <CustomCheckBox isDark={isDark} caption={lic} key={index}
                                              onClick={() => {
                                                if (values.crewSelectedLicenses.indexOf(lic) === -1) {
                                                  setFieldValue('crewSelectedLicenses', [...values.crewSelectedLicenses, lic])
                                                } else {
                                                  setFieldValue('crewSelectedLicenses', [...values.crewSelectedLicenses].filter(s => s.id !== lic))
                                                }
                                              }}
                                              isChecked={values.crewSelectedLicenses.indexOf(lic) !== -1}
                                              color={'#575758'} fontFamily={'Lato600'}/>
                            ))}
                          </div>
                          <div className="w-48">
                            <CustomCheckBox isDark={isDark} caption={t('no')}
                                            onClick={() => setFieldValue('crewSelectedLicenses', null)}
                                            isChecked={values.crewSelectedLicenses === null}
                                            color={'#575758'} fontFamily={'Lato600'}/>
                          </div>
                        </div>
                      </> : <>
                        {values.licenses && values.licenses.map((lic, index) => <div
                          className={`${css.resume__item} mb-16`}
                          key={index}>
                          <p className={css.resume__value}>
                            <img src={circle} alt=""/>
                            {lic.name}
                          </p>
                        </div>)}
                      </>}
                      <p
                        className={`${css.resume__text}`}>7.4. {isEdit ? t('isCrewBoat') : t('boat')}</p>
                      {isEdit && <div className={'modal__row space-between'}>
                        <div className="w-48">
                          <CustomCheckBox isDark={isDark} caption={t('yes')} isChecked={values.crewIsOwnBoat}
                                          onClick={() => setFieldValue('crewIsOwnBoat', true)}
                                          color={'#575758'} fontFamily={'Lato600'}/>
                        </div>
                        <div className="w-48">
                          <CustomCheckBox isDark={isDark} caption={t('no')} isChecked={!values.crewIsOwnBoat}
                                          onClick={() => setFieldValue('crewIsOwnBoat', false)}
                                          color={'#575758'} fontFamily={'Lato600'}/>
                        </div>
                      </div>}
                      {(values.crewIsOwnBoat || !isEdit) && <div className={css.resume__inputs}>
                        <ResumeInput caption={t('type')} value={values.crewBoat}
                                     isEdit={isEdit} handleChange={handleChange}
                                     id={'crewBoat'} type={'text'} isArrow={true}
                                     list={props.yachtTypes.map((y, index) => (
                                       <button className="modal__listItem"
                                               onClick={() => setFieldValue('crewBoat', y.name)} key={index}>
                                         {y.name}
                                       </button>))}/>
                        <ResumeInput caption={t('length')} value={values.crewBoatLength}
                                     isEdit={isEdit} handleChange={handleChange}
                                     id={'crewBoatLength'} type={'number'} isArrow={true} inputWidth={106}
                                     postCaption={'m'}/>
                        <ResumeInput caption={t('port')} value={values.crewPort}
                                     isEdit={isEdit} handleChange={handleChange}
                                     id={'crewPort'} type={'text'}/>
                      </div>}
                      <p
                        className={`${css.resume__text}`}>7.5. {isEdit ? t('isCrewCharteredBefore') : t('chartersBefore')}</p>
                      <div className="modal__row">
                        <p className={`${css.resume__text} mr-12 mt-0`}>1.</p>
                        <div className={`${css.resume__inputs} w-100`}>
                          <ResumeInput caption={t('charterCompany')} value={values.crewCompany}
                                       isEdit={isEdit} handleChange={handleChange}
                                       id={'crewCompany'} type={'text'} setFieldValue={setFieldValue}/>
                          <div className={css.resume__item}>
                            <p className={css.resume__label}>{t('dates')}</p>
                            {isEdit ? <div className="modal__date w-48 mb-24">
                              <div className="modal__dateItem w-48 mr-12">
                                <img src={calendar} alt="" className=""/>
                                <Field placeholder={t('startDate')} className={'modal__dateInput w-100'} type="text"
                                       value={getFormattedDate(state[0].startDate) !== '...' ? getFormattedDate(state[0].startDate) : ''}/>
                                <div className="modal__calendar">
                                  <DateRange
                                    editableDateInputs={true}
                                    onChange={item => setState([item.selection])}
                                    moveRangeOnFirstSelection={false}
                                    ranges={state}
                                    months={2}
                                    className={'datePicker'}
                                    direction={'horizontal'}
                                    showDateDisplay={false}
                                    rangeColors={['#2196F3']}
                                  />
                                </div>
                              </div>
                              <img src={line} alt=""/>
                              <div className="modal__dateItem w-48 ml-12">
                                <img src={calendar} alt="" className=""/>
                                <Field className={'modal__dateInput w-100'} type="text" placeholder={t('finishDate')}
                                       value={getFormattedDate(state[0].endDate) !== '...' ? getFormattedDate(state[0].endDate) : ''}/>
                                <div className="modal__calendar">
                                  <DateRange
                                    editableDateInputs={true}
                                    onChange={item => setState([item.selection])}
                                    moveRangeOnFirstSelection={false}
                                    ranges={state}
                                    months={2}
                                    className={'datePicker'}
                                    direction={'horizontal'}
                                    showDateDisplay={false}
                                    rangeColors={['#2196F3']}
                                  />
                                </div>
                              </div>
                            </div> : <p className={css.resume__value}>
                              {getFormattedDate(values.crewFromDate) !== '...' ? getFormattedDate(values.crewFromDate) : ''} - {
                              getFormattedDate(values.crewToDate) !== '...' ? getFormattedDate(values.crewToDate) : ''}
                            </p>}
                          </div>
                          <ResumeInput caption={t('role')} value={values.crewRole}
                                       isEdit={isEdit} handleChange={handleChange}
                                       id={'crewRole'} type={'text'} isArrow={true}
                                       list={roles.map((y, index) => <button className="modal__listItem"
                                                                             onClick={() => setFieldValue('crewRole', y)}
                                                                             key={index}>
                                         {y}
                                       </button>)}/>
                          <ResumeInput caption={t('sizeTypeBoat')} value={values.crewBoatType}
                                       isEdit={isEdit} handleChange={handleChange}
                                       id={'crewBoatType'} type={'text'}/>
                          <ResumeInput caption={t('nm')} value={values.crewNm}
                                       isEdit={isEdit} handleChange={handleChange}
                                       id={'crewNm'} type={'number'}/>
                          <ResumeInput caption={t('days')} value={values.crewDays}
                                       isEdit={isEdit} handleChange={handleChange}
                                       id={'crewDays'} type={'number'}/>
                          <ResumeInput caption={t('sailingArea')} value={values.crewAreas}
                                       isEdit={isEdit} handleChange={handleChange}
                                       id={'crewAreas'} type={'text'}/>
                        </div>
                      </div>
                      <button className={css.resume__showMore}>
                        <img src={plusIcon} alt=""/>
                        {t('addAnotherTrip')}
                      </button>
                      <p
                        className={`${css.resume__text}`}>7.6. {isEdit ? t('identifyCrewExp') : t('knowAndExpLabel')}</p>
                      <div className={css.resume__inputs}>
                        {[isEdit ? experiences : values.crewSelectedExperience][0].map((exp, index) => <div
                          className={'w-48'}
                          key={index}>
                          <CustomCheckBox isDark={isDark} caption={exp} color={'#252526'} fontFamily={'Lato400'}
                                          isChecked={values.crewSelectedExperience.indexOf(exp) !== -1} onClick={() => {
                            if (isEdit) {
                              if (values.crewSelectedExperience.indexOf(exp) !== -1) {
                                setFieldValue('crewSelectedExperience', [...values.crewSelectedExperience].filter(s => s !== exp))
                              } else {
                                setFieldValue('crewSelectedExperience', [...values.crewSelectedExperience, exp])
                              }
                            }
                          }}/>
                        </div>)}
                      </div>
                    </>}
                  </div>
                </div>
                <div className="modal__section">
                  <p className={css.resume__certificate}>{t('iCertify')}</p>
                  <p className={css.resume__date}>{t('date')}: 18.12.2020</p>
                </div>
                {isEdit && <div className="modal__buttons pr-0">
                  <div className="modal__actions">
                    <button onClick={() => {
                      onSave(values, setFieldError)
                    }} className={`modal__save mr-12 ${isDark && 'modal__saveDark'}`}>
                      <span className="commonBtn__label modal__saveLabel">{t('save')}</span>
                    </button>
                    <button onClick={() => {
                      onSave(values, setFieldError)
                      setIsSendResume(true)
                    }} className="submit-button">
                      {t('send')}
                    </button>
                  </div>
                  <button onClick={() => setIsEdit(false)} className={`commonBtn ${isDark && 'commonBtn__dark'}`}>
                    <span className="commonBtn__label">{t('cancel')}</span>
                  </button>
                </div>}
              </div>
            }}
          </Formik>}
      </>}
    </div>
  );
};

const mapStateToProps = (state) => ({
  yachtTypes: state.dataReducer.yachtTypes,
  marinas: state.dataReducer.marinas,
  licenses: state.profileReducer.licenses,
  trips: state.logbookReducer.trips,
  user: state.userReducer.user,
  resume: state.profileReducer.resume,
  resumeLicenses: state.profileReducer.resumeLicenses,
  resumeCharters: state.profileReducer.resumeCharters,
  profile: state.userReducer.profile,
  experience: state.logbookReducer.experience
})

export default connect(mapStateToProps, {
  getLicenses, getCommonData,
  getResume, getResumeLicenses, addResumeLicenses, updateResume,
  getResumeCharters, addResumeCharters, sendConfirmEmail, setTrips,
  updateProfile
})(React.memo(Resume))
